'use strict';

require('../../style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/index.js
 ** module id = 240
 ** module chunks = 0
 **/